// eslint-disable-next-line import/prefer-default-export
export const CREATE_PRICING = 'emissionPolicy/CREATE_PRICING';

export const UPDATE_ANNUAL_PAYMENT = 'emissionPolicy/UPDATE_ANNUAL_PAYMENT';
export const UPDATE_MONTHLY_PAYMENT = 'emissionPolicy/UPDATE_MONTHLY_PAYMENT';

// Yappy related identifiers
export const REQUEST_YAPPY_PAYMENT = 'emissionPolicy/YAPPY_PAYMENT';
export const REQUEST_PERSISTED_DATA = 'emissionPolicy/REQUEST_PERSISTED_DATA';
export const REQUEST_FAILURE_STATUS = 'emissionPolicy/REQUEST_FAILURE_STATUS';

// Evicertia related indentifiers
export const REQUEST_EVICERTIA_DATA = 'emissionPolicy/REQUEST_EVICERTIA_DATA';

// Save Emission related data
export const REQUEST_EMISSION_SAVE_DATA =
  'emissionPolicy/REQUEST_EMISSION_SAVE_DATA';

// Consulting Emission related data
export const REQUEST_CONSULT_EMISSION_DATA =
  'emissionPolicy/REQUEST_CONSULT_EMISSION_DATA';

// Request Upload Emission Files
export const REQUEST_UPLOAD_EMISSION_FILES =
  'emissionPolicy/REQUEST_UPLOAD_EMISSION_FILES';
export const REQUEST_UPLOAD_PAYMENT_FILE =
  'emissionPolicy/REQUEST_UPLOAD_PAYMENT_FILE';
export const REQUEST_UPLOAD_CEDULA_FILE =
  'emissionPolicy/REQUEST_UPLOAD_CEDULA_FILE';
export const REQUEST_UPLOAD_CEDULA_OPTIONAL_FILE =
  'emissionPolicy/REQUEST_UPLOAD_CEDULA_OPTIONAL_FILE';

// Update emission data
export const REQUEST_UPDATE_EMISSION_DATA =
  'emissionPolicy/REQUEST_UPDATE_EMISSION_DATA';

// request fractionation
export const REQUEST_FRACTIONATION = 'emissionPolicy/FRACTIONATION';

// request upselling
export const REQUEST_UPSELLING = 'emissionPolicy/UPSELLING';
